import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext, ShipDataType } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { PrintShipViewData } from "./Context"
import { PrintShipInsideViewProps } from "./Params"

// Interior layout (berths, cabins, saloon…). Detail-level section.
export function PrintShipInsideView({ data }: PrintShipInsideViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const context = useContext(PrintShipViewContext);
  const includeShipDataType = context?.includeShipDataType || ShipDataType.short;
  const visible = includeShipDataType === ShipDataType.details;

  return (
    <PrintListBlock title={t("inside")} visible={visible}>
      <BlockRow className="block-row-separated">
        <BlockField label={t("berth_no")} className="block-field-120">{shipData?.berthNo}</BlockField>
        <BlockField label={t("berth_single_no")} className="block-field-120">{shipData?.berthSingleNo}</BlockField>
        <BlockField label={t("berth_double_no")} className="block-field-120">{shipData?.berthDoubleNo}</BlockField>
        <BlockField label={t("berth_extra_no")} className="block-field-120">{shipData?.berthExtraNo}</BlockField>
        <BlockField label={t("cabins_no")} className="block-field-120">{shipData?.cabinsNo}</BlockField>
        <BlockField label={t("bath_no")} className="block-field-120">{shipData?.bathNo}</BlockField>
      </BlockRow>

      <BlockRow>
        <BlockField label={t("saloon")} className="block-field-180">{shipData?.saloon}</BlockField>
        <BlockField label={t("pantry")} className="block-field-180">{shipData?.pantry}</BlockField>
        <BlockField label={t("cabins")} className="block-field-180">{shipData?.cabins}</BlockField>
        <BlockField label={t("cockpit")} className="block-field-180">{shipData?.cockpit}</BlockField>
      </BlockRow>
    </PrintListBlock>
  );
}
